import moment from 'moment';
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import connect from 'components/lib/connect';
import AttributeDef from 'models/configuration/attribute_def';
import CustomAttributeBase from './custom_attribute_base';
import DatePickerMenu from 'components/lib/date_picker_menu';
import UpdateCustomAttributes from 'actions/customer_profile/update_custom_attributes';

function EditableDateCustomAttribute({ def, value, isDisabled, isResponsePending, onChange, placeholderText }) {
  let renderedValue = (
    <DatePickerMenu
      className="editableCustomAttribute-datePicker"
      isDisabled={isDisabled || isResponsePending}
      onChange={onChange}
      date={value ? moment(value).toISOString() : value}
      placeholderText={placeholderText}
    />
  );

  return (
    <CustomAttributeBase label={def.label}>
      <div className="editableDateCustomAttribute-value">{renderedValue}</div>
    </CustomAttributeBase>
  );
}

EditableDateCustomAttribute.propTypes = {
  def: PropTypes.instanceOf(AttributeDef).isRequired,
  value: PropTypes.any,
  isDisabled: PropTypes.bool,
  isResponsePending: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  placeholderText: PropTypes.string,
};

export { EditableDateCustomAttribute };

const EditableDateCustomAttributeContainer = connect(mapStateToProps, mapExecuteToProps)(EditableDateCustomAttribute);

function mapStateToProps({ getProvider }, { def }) {
  let profileProvider = getProvider('profile');

  return {
    def,
    value: _.get(profileProvider.get(), ['customAttributes', def.attr]),
    isDisabled: profileProvider.isLoading() || !_(profileProvider.getErrors()).isEmpty(),
    isResponsePending: profileProvider.isPending(),
  };
}

function mapExecuteToProps(executeAction, { def }) {
  return {
    onChange: value => executeAction(UpdateCustomAttributes, { [def.attr]: value }),
  };
}

export default EditableDateCustomAttributeContainer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/summary/custom_attributes/editable_date_custom_attribute.jsx